import { Component, OnInit } from '@angular/core';
import { ClorasApiService } from '../../../+data/sunrise/Services/cloras-api.service';
import { ClientService } from '../../../shared/services/client.service';
import { AuthService } from "../../../shared/services/auth.service";
import { NotificationModel } from 'src/app/shared/models/notification.model';
import { AppCode } from 'src/app/app.code';
@Component({
  selector: 'app-create-user',
  templateUrl: './create-user.component.html',
  styleUrls: ['./create-user.component.css']
})
export class CreateUserComponent implements OnInit {
  //declarations
  loading = false;
  clientId: any;
  model: any = {};
  keyError: boolean = false;
  userData: any = [];
  client: any = {};
  errors: string;
  finalResonse: boolean = false;
  finalResonseMessage: string;

  constructor(private clorasAPIService: ClorasApiService, private clientService: ClientService, private authService: AuthService, private appCode: AppCode) {
    this.client = this.clientService.getClient();
    if(this.client != null) {
      this.clientId = this.client.clientId;
    }
  }

  ngOnInit() {

  }

  //check user in P21 DB
  checkUserAuthorization() {
    this.errors = "";
    this.loading = true;
    let result = {
      "email": this.model.email
    };

    this.clorasAPIService.SunriseApiCall(result, "checkUserStatus").subscribe(async(res: any) => {
      this.userData = await res.data;
      //check user is in DB
      if (this.userData.Message == "Unable to get the contact information") {
        this.keyError = false;
        this.errors = "Your email-id does not exist in Sunrise P21 Database. Please contact kkalish@sunriseelectric.com to create an account.";
      }
      else {
        //this.clientId = 152; //for local use required client-id;
        this.authService.listUsers(this.clientId)
          .subscribe(async(res) => {
            for (let resemail of await res) {
              let result = resemail.email;
              if (result == this.model.email.toLowerCase()) {
                this.errors = "This username is already in use!";
                this.keyError = false;
                this.loading = false;
                return;
              }
              else {
                //multiple list for loop
                for (let result of this.userData) {
                  this.model.email = this.model.email;
                  //this.model.userId = this.model.email;
                  this.model.userName = this.model.email;
                  this.model.firstName = result.first_name;
                  this.model.lastName = result.last_name;
                  this.model.IsActive = true;
                  if (result.contact_role_uid == "" || result.contact_role_uid == null) {
                    this.errors = "Your email-id is not authorized. Please contact kkalish@sunriseelectric.com";
                    this.loading = false;
                    this.keyError = false;
                    return;
                  }
                  else {
                    this.model.roles = [];
                    //assign Role using p21 UID
                    /*
                      --E81F0CFC-C989-4990-9E59-95D481C0274F - 9 - SunriseAdmin
                      --06570CF9-E448-4BFF-AC73-B95059E7246C - 10 - SunriseInternal
                      --5097F145-B4AD-4163-9EDF-A552B57BC5B7 - 11 - SunriseAuthoriser
                     */
                    if (this.model.roles == null || this.model.roles.length == 0) {
                      if (result.contact_role_uid == "9") {
                        //this.model.roles = "SunriseAdmin";
                        this.model.roles.push({ Id: 'E81F0CFC-C989-4990-9E59-95D481C0274F', Name: "SunriseAdmin" });
                      }
                      else if (result.contact_role_uid == "10") {
                        //this.model.roles = "SunriseInternal";
                        this.model.roles.push({ Id: '06570CF9-E448-4BFF-AC73-B95059E7246C', Name: "SunriseInternal" });
                      }
                      else if (result.contact_role_uid == "11") {
                        //this.model.roles = "SunriseAuthorization";
                        this.model.roles.push({ Id: '5097F145-B4AD-4163-9EDF-A552B57BC5B7', Name: "SunriseAuthoriser" });
                      }
                    }
                  }
                  //open password field
                  this.keyError = true;
                }
              }
            }
          });
      }
      this.loading = false;
      (error) => {
        this.loading = false;
        console.log('Error : ' + JSON.stringify(error));
      }
    });
  }

  //change Email 
  changeEmail() {
    this.errors = "";
    this.keyError = false;
    this.model.password = "";
    this.model.confirmPassword = "";
  }

  //create user in DB
  createUser() {
    this.errors = "";
    this.loading = true;
    if (this.model.password != this.model.confirmPassword) {
      this.errors = "Password does not match confirm password!";
      this.loading = false;
      return;
    }
    this.client = this.clientService.getClient();
    if (this.client != null) {
      this.clientId = this.client.clientId;
    }
    //this.clientId = 152; //for local use required client-id;
    this.model.clientId = this.clientId;
    this.model.sendNotification = true;
    this.authService.register(this.model)
        .subscribe(async data => {
          //this.finalResonseMessage = "Email id '" + this.model.email + "' has been successfully registered with <br/><b>Sunrise Electric Customer Service System. </b> <br/> Thank You!";

          var notificationModel = new NotificationModel();
          notificationModel.clientId = this.clientId;
          notificationModel.userId = data.id;
          notificationModel.email = data.email;

          var notificationResult = await this.appCode.sendVerificationEmailToUserAndAdmin(notificationModel);
          if (notificationResult == true) {
            this.finalResonseMessage = "We have sent an email for varification to '" + this.model.email + "'. Please check your email and click on varification link. <br/><b>Sunrise Electric Customer Service System. </b> <br/>" +
              "thank you!";
            this.loading = false;
            this.finalResonse = true;
            this.keyError = false;
          }        
          console.log("Success " + JSON.stringify(data));
        },error => {
          this.finalResonseMessage = "Some error occurred. Please contact to 'kkalish@sunriseelectric.com' for assist.";
          this.finalResonse = true;
          this.loading = false;
          this.errors = error;
          this.keyError = false;
          return;
        });
  }
}
